import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { ContextGraphQueryFact } from '@/types/context-graph-types';

interface QueryResponse {
  graph_id: string;
  facts: ContextGraphQueryFact[];
}

export const queryContextGraph = async (
  graphId: string,
  query: string,
  limit = 6,
): Promise<ContextGraphQueryFact[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<QueryResponse>({
    url: `/context-graphs/${orgId}/${graphId}/query`,
    method: 'POST',
    body: { query, limit, max_hops: 1 },
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  return response.data?.facts ?? [];
};
